 // userSlice.js
import { createSlice } from '@reduxjs/toolkit';

type AuthState = {
  user: any,
  status: any,
};
 const initialState:AuthState = {
   user: null,
   status: 'idle', // Default status is set to 'idle'
 };

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loginUser: (state, action) => {
      state.user = action.payload;
      state.status = 'success'; // Set status to 'success' after successful login
    },
    logoutUser: (state) => {
      state.user = null;
      state.status = 'idle'; // Set status back to 'idle' after logout
    },
    setUserLoading: (state) => {
      state.status = 'loading'; // Set status to 'loading' when authentication process is in progress
    },
    setUserError: (state) => {
      state.user=null
      state.status = 'error'; // Set status to 'error' when authentication fails
    },
  },
});

export const { loginUser, logoutUser,setUserLoading,setUserError } = userSlice.actions;
export default userSlice.reducer;  
